module.exports = __webpack_public_path__ + "static/media/0011.8a360156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors_colored/N02_black/0011.png
// module id = 1364
// module chunks = 0